import React, { useState, useEffect, useMemo, useRef } from 'react';
import { aNumero, formatearConPuntos } from '../../services/numeros';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg'; 
import { ReactComponent as MenuIcon } from '../../assets/icons/MenuIcon.svg';
import { ReactComponent as StaffIcon } from '../../assets/icons/StaffIcon.svg';
import CalendarModal from './CalendarModal'
import { getAuth } from 'firebase/auth';
import { useNavigate, useParams } from 'react-router-dom';
import { Combobox } from '@headlessui/react';
const DemostracionesForm = () => {
const formatNumberWithDots = formatearConPuntos;
const normalizePrice = aNumero;
const { id } = useParams();
const isEditing = !!id;
const [isCalendarModalVisible, setIsCalendarModalVisible] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saved'
const [progress, setProgress] = useState(0);
const navigate = useNavigate();
const [formData, setFormData] = useState({
fechas: [],
hora: '',
titulo: '',
descripcion: '',
coleccion: [],
precio: '',
cantidadPlazas: '',
staff: [
{ nombre: '', rol: 'Staff' },
],
});
const [vinos, setVinos] = useState([]);
const [selectedVino, setSelectedVino] = useState('');
const [vinoQuery, setVinoQuery] = useState('');
const fileInputRef = useRef(null);
const formatDateTimeDisplay = (fechas, hora) => {
if (fechas.length === 0) return 'Seleccionar fecha y hora';
const date = fechas[0];
const formattedDate = date.toLocaleDateString('es-ES', { 
weekday: 'short', 
day: 'numeric', 
month: 'short', 
year: 'numeric' 
});
const capitalizedDate = formattedDate.substring(0, 1).toUpperCase() + formattedDate.substring(1);
return `${capitalizedDate} ${hora || ''}`.trim();
};
const dateTimeDisplay = useMemo(() => formatDateTimeDisplay(formData.fechas, formData.hora), [formData.fechas, formData.hora]);
useEffect(() => {
const fetchAllData = async () => {
setIsLoading(true);
try {
const vinosSnapshot = await getDocs(query(collection(db, 'stock'), where('cantidadUnidades', '>', 0)));
const vinosList = vinosSnapshot.docs
.map(doc => ({ id: doc.id, ...doc.data() }))
.filter(vino => vino.vino_id && !vino.id.startsWith('DEMO-')); // demo de fincalosastros
vinosList.sort((a, b) => a.id.localeCompare(b.id, 'es', { sensitivity: 'base' }));
setVinos(vinosList);
if (isEditing && id) {
const docRef = doc(db, "demostraciones", id);
const docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const demoData = docSnap.data();
const vinoIdsFromNames = demoData.coleccion
.map(nombreVino => {
const vinoEncontrado = vinosList.find(v => v.id === nombreVino);
return vinoEncontrado ? vinoEncontrado.vino_id : null;
})
.filter(vinoId => vinoId);
const loadedFechas = demoData.fechas.map(f => {
return f.seconds ? new Date(f.seconds * 1000) : new Date(f);
});
setFormData({
fechas: loadedFechas.slice(0, 1), 
hora: demoData.hora || '',
titulo: demoData.titulo || '',
descripcion: demoData.descripcion || '',
coleccion: vinoIdsFromNames,
precio: demoData.precio ? formatNumberWithDots(demoData.precio.toString()) : '',
cantidadPlazas: demoData.cantidadPlazas || '',
staff: demoData.staff || [{ nombre: '', rol: 'Staff' }],
});
} else {
console.log("No se encontró el documento.");
navigate('/eventos');
}
}
} catch (error) {
console.error("Error al cargar datos:", error);
} finally {
setIsLoading(false);
}
};
fetchAllData();
}, [id, isEditing, navigate]);
const handleStaffChange = (e, index) => {
const { value } = e.target;
const newStaff = [...formData.staff];
newStaff[index].nombre = value;
setFormData({ ...formData, staff: newStaff });
};
const handleAddStaff = () => {
setFormData({ 
...formData, 
staff: [...formData.staff, { nombre: '', rol: 'Staff' }] 
});
};
const handleRemoveStaff = (index) => {
const newStaff = [...formData.staff];
newStaff.splice(index, 1);
setFormData({ ...formData, staff: newStaff });
};
const handleAddVino = (vinoId) => {
if (vinoId && !formData.coleccion.includes(vinoId)) {
setFormData({
...formData,
coleccion: [...formData.coleccion, vinoId],
});
setSelectedVino('');
}
};
const handleRemoveVino = (index) => {
const newColeccion = [...formData.coleccion];
newColeccion.splice(index, 1);
setFormData({ ...formData, coleccion: newColeccion });
};
const availableVinos = vinos.filter(
(vino) => !formData.coleccion.includes(vino.vino_id)
);
const filteredVinos =
vinoQuery === ''
? availableVinos
: availableVinos.filter((vino) => {
const vinoNombreCompleto = `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}`;
return vinoNombreCompleto.toLowerCase().includes(vinoQuery.toLowerCase());
});
const handleOpenCalendarModal = () => {
setIsCalendarModalVisible(true);
};
const handleCloseCalendarModal = () => {
setIsCalendarModalVisible(false);
};
const handleDatesSelected = ({ selectedDates, selectedTime }) => {
const date = selectedDates.length > 0 ? selectedDates[0] : null;
setFormData({
...formData,
fechas: date ? [date] : [],
hora: selectedTime,
});
handleCloseCalendarModal();
};
const handleChange = (e) => {
const { name, value } = e.target;
if (name === "precio") {
setFormData({ ...formData, [name]: formatNumberWithDots(value) });
} else if (name === "cantidadPlazas") {
const cleanedValue = value.replace(/[^\d]/g, '');
setFormData({ ...formData, [name]: cleanedValue });
} else {
setFormData({ ...formData, [name]: value });
}
};
const handleSubmit = async (e) => {
e.preventDefault();
setIsLoading(true);
setSaveState('idle');
setProgress(0);
const user = getAuth().currentUser;
if (!user) {
console.error("Usuario no autenticado.");
setIsLoading(false);
return;
}
let fakeProgress = 0;
const interval = setInterval(() => {
fakeProgress += 10;
setProgress(fakeProgress);
if (fakeProgress >= 90) clearInterval(interval);
}, 200);
try {
const idToken = await user.getIdToken();
const formDataToSend = new FormData();
formDataToSend.append("titulo", formData.titulo);
formDataToSend.append("descripcion", formData.descripcion);
formDataToSend.append("precio", normalizePrice(formData.precio));
formDataToSend.append("hora", formData.hora);
formDataToSend.append("fechas", JSON.stringify(formData.fechas.slice(0, 1))); 
formDataToSend.append("coleccion", JSON.stringify(formData.coleccion));
formDataToSend.append("staff", JSON.stringify(formData.staff.filter(s => s.nombre)));
formDataToSend.append("cantidadPlazas", Number(formData.cantidadPlazas));
const endpoint = isEditing 
? `https://backend-288175208699.europe-west1.run.app/actualizar-demostracion/${id}` 
: "https://backend-288175208699.europe-west1.run.app/nueva-demostracion";
const method = isEditing ? "PUT" : "POST";
const res = await fetch(endpoint, {
method: method,
headers: {
Authorization: `Bearer ${idToken}`,
},
body: formDataToSend,
});
const data = await res.json();
if (!res.ok) throw new Error(data.error || "Error en la operación");
clearInterval(interval);
setProgress(100);
setSaveState('saved');
setTimeout(() => {
navigate('/eventos');
}, 800);
} catch (error) {
alert(error.message);
setIsLoading(false);
setProgress(0);
}
};
return (
<div style={{ padding: '0 16px', overflow: 'hidden', height: '100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Demostraciones</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<MenuIcon className="formicon" style={{overflow:'visible', height: 'auto', width:'17px', margin: 'auto' }} />
</div>
<h1 className="formtitle"> {isEditing ? "Actualizar demostración" : "Crear una nueva demostración"}</h1>
</div>
<hr className="divider" />
<form className="form" onSubmit={handleSubmit} style={{ maxHeight: '75vh' }}>
{}
<div className="eventos-form-grid-container" style={{ 
display: 'grid', 
gridTemplateColumns: '1fr 1fr 1fr', 
gap: '20px',
marginBottom: '20px'
}}>
{}
<div className="eventos-form-column-1" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
{}
<div className="eventos-form-input" onClick={() => handleOpenCalendarModal()} style={{ borderRadius: '7px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
<span >
{dateTimeDisplay}
</span>
</div>
{}
<div className="eventos-form-input-group">
<input className="eventos-form-input eventos-form-large-input" type="text" id="titulo" name="titulo" value={formData.titulo} onChange={handleChange} placeholder="Título de la demostración" required />
</div>
{}
<div className="eventos-form-input-group" style={{ display: 'flex', gap: '0', flexDirection: 'column', borderRadius: '7px', backgroundColor: '#f6f7fa', flexGrow: 1 }}>
<textarea 
className="eventos-form-input eventos-form-large-input" 
id="descripcion" 
name="descripcion" 
value={formData.descripcion} 
onChange={handleChange} 
rows={5} 
placeholder="Descripción de la demostración" 
style={{ flexGrow: 1 }}
/>
</div>
</div>
{}
<div className="eventos-form-column-2" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
<div className="eventos-form-input-group" style={{ flexGrow: 1 }}>
<div className="input-group">
<Combobox
value={selectedVino}
onChange={(value) => {
handleAddVino(value);
setVinoQuery('');
}}
>
{({ open }) => (
<>
<div style={{ position: 'relative', width: '100%' }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? 'open' : ''} ${selectedVino ? 'selected' : 'placeholder'}`}
style={{ width: '90.25%', borderRadius: '5px' }}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => setVinoQuery(event.target.value)}
displayValue={(vinoId) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
return vino ? `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}` : '';
}}
placeholder="Selecciona un vino"
style={{ flexGrow: 1, padding: '0', border: 'none', outline: 'none', backgroundColor: 'transparent', }}
/>
<span className="custom-arrow-container" style={{ marginRight: '5px' }}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options">
{filteredVinos.length === 0 && vinoQuery !== '' ? (
<div className="custom-listbox-option">No se encontraron vinos.</div>
) : (
filteredVinos.map((vino) => (
<Combobox.Option
key={vino.vino_id}
value={vino.vino_id}
className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`}
>
{`${vino.id}`}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
</>
)}
</Combobox>
</div>
{}
{formData.coleccion.length > 0 && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '5px', flexWrap: 'wrap', marginTop: '10px' }}>
{formData.coleccion.map((vinoId, index) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
if (!vino) return null;
return (
<div key={index} className="eventos-form-input-group number" style={{ minWidth: '80px', borderRadius: '50px', maxWidth: '100%', padding: '5px 10px ' }}>
<span style={{ cursor: 'default', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}>{vino.id}</span>
<div className="add-fecha" style={{ right: '5px', background: 'none', fontSize: '17px' }} onClick={() => handleRemoveVino(index)}>
&times;
</div>
</div>
);
})}
</div>
)}
</div>
</div>
{}
<div className="eventos-form-column-3" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
{}
<div className="eventos-form-sub-column">
<div className="eventos-form-label-container">
<StaffIcon className="eventos-form-icon" />
<label className="eventos-form-label">Staff</label>
</div>
<div className="eventos-form-input-group eventos-form-array">
{formData.staff.map((item, index) => (
<div key={index} className="eventos-form-array-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
<input 
className="eventos-form-input" 
type="text" 
name="nombreStaff"
value={item.nombre}
onChange={(e) => handleStaffChange(e, index)}
placeholder={`Nombre del integrante`} 
style={{ flex: 1 }}
/>
{index > 0 && (
<div 
className="add-fecha" 
style={{ right: '5px', background: 'none', fontSize: '17px', cursor: 'pointer', position:'relative' }} 
onClick={() => handleRemoveStaff(index)}>
&times;
</div>
)}
</div>
))}
<div type="button" onClick={handleAddStaff} className="add-btn-container" style={{ cursor: 'pointer' }}>
<span className="add-icon">+</span>
<span className="add-txt">Agregar otro integrante</span>
</div>
</div>
</div>
{}
<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
<div className="eventos-form-input-group number" style={{justifyContent:'start',gap: '10px' }}>
<ClientesIcon style={{width:'13px', marginLeft:'15px'}}/>
<input
className="eventos-form-input"
type="text"
id="cantidadPlazas"
name="cantidadPlazas"
value={formData.cantidadPlazas}
onChange={handleChange}
placeholder="Máximo de plazas"
inputMode="numeric"
pattern="[0-9]*"
required
style={{paddingLeft:'0'}}
/>
</div>
<div className="eventos-form-input-group number">
<input
className="eventos-form-input"
type="text"
id="precio"
name="precio"
value={formData.precio}
onChange={handleChange}
placeholder="Valor del evento"
required
/>
<span className="unit">$</span>
</div>
</div>
</div>
</div>
{}
<div className="button-container" style={{ marginTop: '0', display: 'flex', justifyContent: 'flex-end', paddingRight: '20px' }}>
<button
type="submit"
className={`eventos-form-submit-btn ${saveState === 'saved' ? 'success' : ''}`}
disabled={isLoading}
style={{ width: '300px' }}
>
<span className="button-text">
{saveState === 'saved' ? 'Guardado' : isEditing ? "Editar demostración" : "Crear demostración"}
</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button>
</div>
</form>
</div>
<CalendarModal
isVisible={isCalendarModalVisible}
onClose={handleCloseCalendarModal}
onDatesSelect={handleDatesSelected}
showTimeInput={true}
initialDates={formData.fechas}
singleDateSelection={true}
/>
</div>
);
};
export default DemostracionesForm;